import React, { Component } from "react";
import { routes } from "../General";
import axios from "axios";
import ReactNumeric from "../../components/ReactNumeric/ReactNumeric";
import { JedaiCalendarioViewText } from "../../coms/BlkCalendario";
import { Modal, ModalBody } from "reactstrap";
import { Contratante } from "./Contratante";

export class Facturacion extends Component {
    constructor(props) {
        super(...arguments);
        this.alert = React.createRef();
        this.state = {
            item: {},
            financiamientoList: [],
            totalPago: 0,
            totalSaldo: 0,
        };
    }

    componentDidMount() {
        let { open } = this.props;
        if (open) {
            this.fetchData();
        }
    }

    componentDidUpdate(prevProps) {
        let { open } = this.props;
        let openOld = prevProps.open;

        if (open !== openOld) {
            if (open) {
                this.fetchData();
            } else {
                this.setState({ item: {} });
            }
        }
    }

    fetchData() {
        this.getFormaPago();
    }

    getFormaPago = () => {
        let { poliza, item, vida } = this.props;
        let id = "";
        // let id = (poliza.cdRamCotOri != null && (!item.numCotizacion.startsWith('R') && !item.numCotizacion.startsWith('C'))) ? poliza.cdRamCotOri : item.cdRamoCotizacion;
        id = item.cdCotizacion;

        axios
            .get(routes.api + "/polizas/formaPago", {
                params: {
                    cdCompania: this.props.poliza.cdCompania,
                    cdCotizacion: vida ? this.props.poliza.cotizacion.cdCotizacion : id,
                    vam: vida,
                },
            })
            .then(resp => {
                let data = resp.data;
                this.setState({
                    item: data.item,
                    financiamientoList: data.financiamientoList,
                    totalPago: data.totalPago,
                    totalSaldo: data.totalSaldo,
                });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    closeModal = () => {
        this.props.toggleModal(false);
        this.setState({ list: [], item: {} });
    };

    showDetalle = finZ => {
        axios
            .get(routes.api + "/clausulas", {
                params: {
                    cdCompania: 1,
                    cdUbicacion: 666,
                },
            })
            .then(resp => {
                //this.setState({detalle: resp.data});
                this.toggleModalDetalle(true);
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    toggleModalDetalle = open => {
        this.setState({ modalDetalle: open });
    };

    render() {
        let item = this.state.item;
        let ramos = this.props.ramos;

        return (
            <Modal className="text-center modal-xl mx-auto modal-detail" isOpen={this.props.open}>
                <ModalBody>
                    <div className="row">
                        <Contratante
                            poliza={this.props.poliza}
                            item={this.props.item}
                            user={this.props.user}
                            vida={this.props.vida}
                            ramos={ramos}
                        />

                        <div className="col-lg-9 pt-2">
                            <div className={"text-right"}>
                                <button
                                    type="button"
                                    className="close"
                                    title="Cerrar"
                                    onClick={this.closeModal}
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <Pagos
                                item={item}
                                financiamientoList={this.state.financiamientoList}
                                totalPago={this.state.totalPago}
                                totalSaldo={this.state.totalSaldo}
                            />
                            <br />
                            <br />
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}

export const Pagos = ({ item, financiamientoList, totalPago, totalSaldo }) => {
    return (
        <>
            <h5 className="card-title">Facturación</h5>
            <div className="table-responsive">
                <table className="table table-striped table-hover">
                    <thead className="thead-inverse text-primary">
                        <tr>
                            <th className="text-left st-95">Forma Pago</th>
                            <th className="text-right st-95">Prima Neta</th>
                            <th className="text-right st-95">Val. Finan.</th>
                            <th className="text-right st-95">Der. Emi.</th>
                            <th className="text-right st-95">Super Cias</th>
                            <th className="text-right st-95">Seg. Camp</th>
                            <th className="text-right st-95">Otro Valor</th>
                            <th className="text-right st-95">IVA</th>
                            <th className="text-right st-95">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{item.frmPago}</td>
                            <td>
                                <ReactNumeric
                                    valuex={item.totPrima ? item.totPrima : 0}
                                    readOnly
                                    className="form-control-plaintext text-right st-95"
                                />
                            </td>
                            <td>
                                <ReactNumeric
                                    valuex={item.valFinanciamiento ? item.valFinanciamiento : 0}
                                    readOnly
                                    className="form-control-plaintext text-right st-95"
                                />
                            </td>
                            <td>
                                <ReactNumeric
                                    valuex={item.dereEmision ? item.dereEmision : 0}
                                    readOnly
                                    className="form-control-plaintext text-right st-95"
                                />
                            </td>
                            <td>
                                <ReactNumeric
                                    valuex={item.superBancos ? item.superBancos : 0}
                                    readOnly
                                    className="form-control-plaintext text-right st-95"
                                />
                            </td>
                            <td>
                                <ReactNumeric
                                    valuex={item.seguroC ? item.seguroC : 0}
                                    readOnly
                                    className="form-control-plaintext text-right st-95"
                                />
                            </td>
                            <td>
                                <ReactNumeric
                                    valuex={item.valRubro ? item.valRubro : 0}
                                    readOnly
                                    className="form-control-plaintext text-right st-95"
                                />
                            </td>
                            <td>
                                <ReactNumeric
                                    valuex={item.iva ? item.iva : 0}
                                    readOnly
                                    className="form-control-plaintext text-right st-95"
                                />
                            </td>
                            <td>
                                <ReactNumeric
                                    valuex={item.totalPago ? item.totalPago : 0}
                                    readOnly
                                    className="form-control-plaintext text-right st-95"
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <br />

            <h5 className="card-title">Cuotas</h5>
            <div className="table-responsive">
                <table className="table table-striped table-hover">
                    <thead className="thead-inverse text-primary">
                        <tr>
                            <th className="text-left st-95">No.</th>
                            <th className="text-right st-95">Valor</th>
                            <th className="text-right st-95">Saldo</th>
                            <th className="text-left st-95">Fc. Vencimiento</th>
                            <th className="text-left st-95">No Factura</th>
                        </tr>
                    </thead>
                    <tbody>
                        {financiamientoList.map(finZ => (
                            <tr key={finZ.cdFinanciamiento}>
                                <td className="text-left st-95" style={{ width: 10 }}>
                                    {finZ.ordinal}
                                </td>
                                <td className="text-right st-95" style={{ width: 50 }}>
                                    <span>
                                        <ReactNumeric
                                            valuex={finZ.valor}
                                            readOnly
                                            className="form-control-plaintext text-right st-95"
                                        />
                                    </span>
                                </td>
                                <td className="text-right st-95" style={{ width: 80 }}>
                                    <ReactNumeric
                                        valuex={finZ.saldoPago}
                                        readOnly
                                        className="form-control-plaintext text-right st-95"
                                    />
                                </td>
                                <td style={{ width: 100 }} className={"text-left st-95"}>
                                    <JedaiCalendarioViewText value={finZ.fcVencimiento} />
                                </td>
                                <td className={`${finZ.detalles ? "red" : ""} text-left st-95`} style={{ width: 100 }}>
                                    {finZ.factAseg}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td className="text-left st-95">Total</td>
                            <td className="text-left main-color t-bold st-95">
                                <ReactNumeric
                                    valuex={totalPago}
                                    readOnly
                                    className="form-control-plaintext text-lg-left st-95"
                                />
                            </td>
                            <td className="text-left main-color t-bold st-95">
                                <ReactNumeric
                                    valuex={totalSaldo}
                                    readOnly
                                    className="form-control-plaintext text-left st-95"
                                />
                            </td>
                            <td>&#160;</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </>
    );
};
